import { render, staticRenderFns } from "./ShippingAddFormAliquotPrice.vue?vue&type=template&id=efa62f0c&scoped=true"
import script from "./ShippingAddFormAliquotPrice.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormAliquotPrice.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddFormAliquotPrice.vue?vue&type=style&index=0&id=efa62f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa62f0c",
  null
  
)

export default component.exports